import React from "react";
import Footer from "../../components/foot";
//import myImage from "../../images/profile-white-bg.jpg";
import "./index.css";


function AboutPage(){

	return(
		<React.Fragment>

			<section id='about-page'>

				<div className='img-frame'>
					<img src="https://own-portfolio-bucket.s3.eu-west-2.amazonaws.com/images/happyibrahim.webp" alt="Mr Ibrahim B. Oduola in Toon" />
					{/*data-aos="zoom-out-down" data-aos-duration="1500" this added to the image above is causing it not to appear */}
				</div>

				<div className='my-info'>
					<p>
						"If you are persistent, you would have it. If you are consistent, you would keep it". This anonymous quote is deep rooted
						within me and influences my every action. Consistency and hardwork are my biggest virtue. "Average" is simply
						not my thing.
					</p>

					<p>
						I have always admired the prestigious uniform of the merchant navy. To me, it represents discipline and dedication.
						And for that reason, I chose to pursue career at sea. Well, that and the fact that I get to cruise the seas
						- and get paid for it ;). And that would have been all, but again, I'm not your average person. 
					</p>

					<p>
						I do fancy the application of acquired knowledge. To put that more precisely, I fancy the application of scientific
						phenomena in making cool tech stuff. For some reason, I have always found something about computers and technology really
						really fascinating.
					</p>

					<p>
						In 2014, I stumbled upon QBASIC. That's a programming language which is archaic today. I remember making my first batch file
						application that manages files and folders on a windows PC. It has no modern-looking user interface, just a command prompt window
						that ask to press A or B for this or that. Nonetheless, I launched the "stupid" program in front of my paramilitary 
						colleagues as if I'm about to put man on mars. I don't even use the program myself but atleast "I made it a computer do what from scratch".						
					</p>

					<p> So in the words of Dr. Angela Yu, I thought "if this, then what"? </p>

					<p>
						I set out to understand how computers work and that's how I got hooked. It has been an upwards battle for 
						me from there on. I researched, picked up a book ("think python" by Allen B. Downey) and I learnt python. It was really satisfying. Then I 
						learnt a python framework (django) to go with my python skills. It was hectic at first but relentlessly I mastered it. Much of
						my freelancing work is done with this framework till date.
					</p>

					<p>
						I moved on to learn about SQL (database) and API (Application programming Interface) and before I knew it, I was doing
						frontend (web client) things with JavaScript, HTML5, CSS3 and AJAX. I even mastered ReactJS (a Javacript 
						Lbrary that makes working with django so much convinient.)
					</p>

					<p>
						I was doing all these side learnings and development when I was in the university pursuing a BSc. degree in Nautical Science (
						which is completely about navigation of ships). That's not ideal, you may think. I know my capabilities quite well and 
						I GRADUATED WITH A FIRST CLASS DEGREE - like I said, I am not your average person :).
					</p>

					<p>
						With the apparent advancement of technology today (even in the shipping industry), the fields of Artificial Intelligence, 
						internet of things and cyber-security have captured a great deal of my attention and day after day, I work hard on 
						improving my skills and competence in these fields.
					</p>

					<p>
						Every now and then, I write about things I find particularly fascinating 
						(about the maritime industry, AI, technology or the world in general) so be sure to 
						<a href="/blog/">take a look at my blog</a> and feel free to check-out my social media (in the footer) and follow me 
						or connect with me.
					</p>

					<p>
						PS: I enjoy travelling, sightseeing, sports (football majorly) and good (mainly RnB) music. And I also love working
						with geniuses (physically and remotely) irrespective of cultural difference. Thank You for your time.
					</p>

					<div className='cta'>
						<a href="/service/" className='enchanted' > My Freelancing Service </a>
						<a href="/blog/" className='sedated'> My Blog </a>
						<a href="/" className='sedated'> Home Page </a>

					</div>

				</div>

			</section>

			<Footer />

		</React.Fragment>


		)
};

export default AboutPage;